<template>
    <div  style="width: 100%;overflow: hidden;height: 100%;">
            <div v-if="is_login === 1" style="width: 100%;">
                <!--暂无数据-->
                <div v-if="tionReply.length == 0 && loading == false" style="width: 100%;height: 100%;display: flex;justify-content: center;align-items: center;background: #FFFFFF;margin-top: 10px;margin-bottom: 10px;">
                    <el-empty description="暂无评论,赶紧来评论吧"></el-empty>
                </div>
                <!--骨架屏-->
                <div v-if="loading == true" style="overflow: hidden;background: #FFFFFF;margin-bottom: 10px;white-space: pre-wrap;width: calc(100% - 30px;);border-radius: 5px;padding: 0 15px;" >
                    <el-skeleton :rows="6" animated />
                </div>
                <!--数据渲染-->
                <div v-else v-for="(item,index) in tionReply" :key="index">
                    <div  style="overflow: hidden;background: #FFFFFF;margin-bottom: 10px;width: 100%;border-radius: 5px;margin-top: 10px;">
                            <div style="float: left;margin: 5px;padding-left: 25px">
                                <img  src="@/assets/imgs/index/expert.png" style=" width: 25px; height: 25px;"/>
                            </div>
                            <div style="width: auto;height: 26px;color: #FA541C;font-size: 19px;font-weight: bold;padding-top: 5px;">
                                <div style="width: 76%;float: left;">专业回答</div>
                                <div v-if="user.uuid == item.uuid && item.isAdopt == 0 && item.children.length == 0" style="float: right;width: 4%">
                                    <el-dropdown @command="more_action" >
                                        <span class="el-dropdown-link">
                                          <i class="el-icon-caret-bottom" style="font-size: 24px"></i>
                                        </span>
                                        <el-dropdown-menu slot="dropdown" >
                                            <label>
                                                <el-dropdown-item  :command="(item,index)">删除回答</el-dropdown-item>
                                            </label>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </div>
                            </div>
                            <!--   红包问答 采纳按钮  -->
                            <div   v-if="data.rewardType == 1 || data.rewardType == 4">
                                <div v-if="data.uuid === user.uuid">
                                    <div v-if="data.isReward > 0 && item.uuid != user.uuid" style="width: 180px;height: 30px;float: right;margin-top: 5px;" :style="item.isAdopt == 0?'margin-right: -20px;':'margin-right: -185px;'">
                                        <el-dropdown v-if="data.isCutoff == 0 && data.expiredNot == 0 &&  data.payStatus == 1 && item.isAdopt == 0 && data.isPenny == 0" @command="accept($event,index)">
                                            <span class="el-dropdown-link" style="font-size: 14px;padding-top: 5px;margin-left: 55px;color: #F88450;font-weight: bold;cursor: pointer">{{item.answers}}<i class="el-icon-arrow-down el-icon--right"></i></span>
                                            <el-dropdown-menu slot="dropdown">
                                                <el-dropdown-item :command="it.type" :disabled="it.disabled" v-for="(it,ind) in data.pennyList" :key="ind" >{{it.type}}等奖</el-dropdown-item>
                                            </el-dropdown-menu>
                                        </el-dropdown>
                                    </div>
                                </div>
                                <div v-if="data.isReward > 0" style="width: 180px;height: 30px;float: right;margin-right: -5px;margin-top: 5px;">
                                    <el-dropdown v-if="item.isAdopt == 1" >
                                        <!-- <span  style="font-size: 16px;padding-top: 5px;margin-left: 8px;color: #C1C1C1;">{{item.answers}}({{item.award}}等奖)</span>-->
                                        <span  style="font-size: 14px;padding-top: 5px;margin-left: 58px;color: #2970FF;font-weight: bold;cursor: pointer">已采纳({{item.award}}等奖)</span>
                                    </el-dropdown>
                                </div>
                            </div>
                            <!--  悬赏问答 采纳按钮    -->
                            <div v-if="data.rewardType == 2 || data.rewardType == 3">
                                <div v-if="data.uuid === user.uuid">
                                    <div v-if="data.isReward == 1  && item.uuid != user.uuid"   @click="adopt(index)" style="width: 100px;height: 30px;float: right;margin-right: 20px;margin-top: 5px;">
                                        <div v-if="data.isCutoff == 0 && data.expiredNot == 0 &&  data.payStatus == 1 && item.isAdopt == 0"  style="font-size: 14px;padding-top: 5px;margin-left: 20px;cursor:pointer;color: #F88450;font-weight: bold;">采纳答案{{data.award}}</div>
                                    </div>
                                </div>
                                <div v-if="item.isAdopt == 1"  style="width: 100px;height: 30px;float: right;margin-top: 5px;" :style="data.uuid == user.uuid?'margin-right: -100px;':'margin-right: 20px;'">
                                    <div  style="font-size: 14px;padding-top: 5px;margin-left: 40px;color: #2970FF;font-weight: bold;cursor: pointer;">已采纳</div>
                                </div>
                            </div>
                            <div style="margin-left: 30px;margin-top: 20px;margin-right: 30px;" >
                                <div style="width: 40px;height: 40px;float: left;cursor: pointer;"@click="circle(item.uuid,item.user.userType)">
                                    <img :src="item.user.headIco" style="border-radius: 30%;width: 100%;height: 100%;object-fit: cover;">
                                </div>
                                <div style="margin-left: 10px;">
                                    <div style="display: flex; align-items: center;height: 40px;">
                                        <div style="color: #eb7350;font-size: 14px;cursor: pointer;margin-right: 10px;margin-left: 10px;" @click="circle(item.uuid,item.user.userType)">{{item.user.nickName}}</div>
                                        <div v-if="item.user.v === 1" style="margin-top: 5px;margin-right: 10px;">
                                            <img src="@/assets/imgs/index/vipBig.png" style="width: 20px; height: 20px;"/>
                                        </div>
                                        <div v-if="item.user.expertAuthStatus == 2" style="margin-top: 5px;margin-right: 10px;">
                                            <img src="@/assets/imgs/index/major2.png" style="width: 49px; height: 21px;"/>
                                        </div>
                                        <div v-if="item.user.majorAuthStatus == 2" style="margin-top: 5px;margin-right: 10px;">
                                            <img src="@/assets/imgs/index/expertspn2.png" style="width: 49px; height: 21px;"/>
                                        </div>
                                    </div>
                                </div>

                                <div style="width: 99.5%;height: auto;display: flex;margin-bottom: 5px;">
                                    <div style=" color: #555555;font-size: 14px;margin-top: 3px;word-wrap: break-word;width: calc(100% - 0px);line-height:25px;text-shadow: #444444;text-align: left;">{{item.content}}</div>
                                    <div style="width: auto;line-height: 22px;text-align: center;padding: 0 3px;">{{item.likeCount}}</div>
                                    <div @click="clickLike(item.id,index,null,1)" style="width: 20px;height: 20px;cursor: pointer;">
                                        <img v-show="item.isLike == 0" src="@/assets/imgs/other/dianzan.png" style="width: 20px;height: 20px;">
                                        <img v-show="item.isLike == 1" src="@/assets/imgs/other/dianzan2.png" style="width: 20px;height: 20px;">
                                    </div>
                                </div>

                                <!--图片-->
                                <div style="display: flex; flex-wrap: wrap; width: 100%;">
                                    <div  v-for="(i,idx) in item.images" :key="idx">
                                        <div style="width: 350px;height: 350px; margin-right: 10px; margin-bottom: 10px;">
                                            <!-- 图片1 -->
                                            <el-image  style="width: 100%; height: 100%;" :src="i['url']" :preview-src-list="[i['url']]"></el-image>
                                        </div>
                                    </div>
                                </div>

                                <!--视频-->
                                <div v-if="item.videos.length > 0" style="height: 286px;">
                                    <div style="width: 500px;height: auto;" :class="item.auth == 0 ? 'now':'old'">
                                        <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options=videoOptions(item.videos[0].url,item.videos[0].img_url)></video-player>
                                    </div>
                                </div>
                                <!--附件-->
                                <div v-if="item.file.length > 0">
                                    <div v-for="(item,ind) in item.file" :key="ind" >
                                        <div style="width: auto;height: auto">
                                            <div style="display:inline-block;">
                                                <span style="padding-top: 10px;"> <svg  t="1681188831011" class="fuGian" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5155" width="30" height="23"><path d="M881.371429 362.057143v570.514286c0 25.6-18.285714 43.885714-43.885715 43.885714H186.514286c-25.6 0-43.885714-18.285714-43.885715-43.885714v-841.142858c0-25.6 21.942857-43.885714 43.885715-43.885714h431.542857l263.314286 314.514286zM841.142857 365.714286l-223.085714-266.971429L621.714286 329.142857c0 25.6 14.628571 40.228571 29.257143 40.228572L841.142857 365.714286z m-256-285.257143H186.514286c-7.314286 0-10.971429 3.657143-10.971429 10.971428v844.8c0 7.314286 3.657143 10.971429 10.971429 10.971429h650.971428c7.314286 0 10.971429-3.657143 10.971429-10.971429V402.285714h-197.485714c-36.571429 0-62.171429-32.914286-62.171429-73.142857L585.142857 80.457143z" fill="#BEC3CC" p-id="5156"></path><path d="M881.371429 501.028571H142.628571c-18.285714 0-29.257143 7.314286-29.257142 25.6V841.142857c0 14.628571 10.971429 25.6 29.257142 25.6h742.4c18.285714 0 29.257143-7.314286 29.257143-25.6v-318.171428c-3.657143-14.628571-10.971429-21.942857-32.914285-21.942858z m-548.571429 259.657143h-14.628571v-7.314285c-3.657143-7.314286-3.657143-14.628571-3.657143-18.285715H329.142857c10.971429 0 14.628571-7.314286 14.628572-18.285714 0-14.628571-7.314286-32.914286-18.285715-51.2l18.285715-69.485714h-29.257143v204.8h-25.6v-230.4H365.714286v25.6l-18.285715 65.828571c14.628571 18.285714 18.285714 36.571429 18.285715 58.514286 0 25.6-10.971429 36.571429-32.914286 40.228571z m76.8-146.285714v186.514286h-25.6V658.285714c0 3.657143-3.657143 7.314286-7.314286 10.971429-3.657143 3.657143-7.314286 10.971429-7.314285 10.971428 0-3.657143-3.657143-10.971429-3.657143-18.285714 0-3.657143-3.657143-10.971429-3.657143-10.971428 18.285714-29.257143 32.914286-58.514286 40.228571-91.428572l25.6 3.657143c-3.657143 10.971429-7.314286 25.6-18.285714 43.885714v7.314286z m113.371429 25.6h-21.942858v120.685714c0 25.6-10.971429 36.571429-32.914285 36.571429H438.857143c0-10.971429-3.657143-18.285714-3.657143-25.6h25.6c14.628571 0 18.285714-3.657143 18.285714-18.285714v-117.028572h-51.2v-25.6h51.2v-51.2h25.6v51.2h21.942857v29.257143z m-106.057143 25.6l21.942857-7.314286c7.314286 18.285714 18.285714 36.571429 25.6 51.2l-21.942857 10.971429c-7.314286-18.285714-18.285714-36.571429-25.6-54.857143z m171.885714 135.314286h-25.6v-128c-7.314286 10.971429-14.628571 25.6-25.6 36.571428-3.657143-14.628571-3.657143-25.6-7.314286-36.571428 18.285714-29.257143 36.571429-65.828571 47.542857-109.714286l25.6 7.314286c-3.657143 18.285714-10.971429 36.571429-18.285714 51.2v179.2z m190.171429-80.457143h-62.171429v76.8h-25.6v-76.8h-84.114286V694.857143h84.114286v-54.857143h-40.228571c-3.657143 14.628571-10.971429 29.257143-14.628572 40.228571-3.657143-3.657143-10.971429-3.657143-18.285714-7.314285-3.657143 0-3.657143 0-3.657143-3.657143 10.971429-25.6 21.942857-54.857143 29.257143-95.085714l25.6 3.657142c-3.657143 10.971429-3.657143 21.942857-7.314286 32.914286h32.914286v-54.857143h25.6v54.857143h54.857143v25.6h-54.857143V694.857143h62.171428v25.6z" fill="#0090FF" p-id="5157"></path></svg></span>
                                                <span style="width:auto;color: #1a1a1a;margin-left:5px;font-size: 14px;display:inline-block; overflow:hidden;white-space: nowrap;text-overflow: ellipsis;cursor: pointer">{{item.name}}</span>
                                                <!-- 判断悬赏资料只有发布者本人可以下载 -->
                                                <div v-if="info.rewardType == 2|| data.uuid === user.uuid" style="color: blue;display:inline-block;margin-left: 10px;cursor:pointer;font-size: 14px;overflow: hidden;" @click="download1(  [index],item['url'],item['name'],item['hash'])">下载</div>
                                                <div v-else style="color: #555;display:inline-block;margin-left: 10px;color:blue;cursor:pointer;font-size: 14px;overflow: hidden;" @click="download1(  [index],item['url'],item['name'],item['hash'])">下载</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!--暂不公开-->
                                <div v-if="item.fileAuth == 0" style="width: 200px;margin-left: 0px;font-size: 12px;color: #1D82FE;line-height: 30px;">{{item.fileAuthRemark}}</div>

                                <!--一级级回复-->
                                <div style="width: calc(100% - 50px);line-height: 25px;cursor: pointer;margin-bottom: 3px;float: left;">
                                    <span @click="clickRep(index,item)" style="font-size: 14px;">回复</span> · <span style="color: #c1c1c1;font-size: 12px;"> {{item.createTime}}</span>
                                </div>
                                <!--多级级回复-->
                                <div v-for="(ite,idx) in item.children" :key="idx" style="width:calc(100% - 50px);height: auto;font-size: 14px;margin-top: 5px;margin-left: 0px;">
                                    <div v-if="idx <= item.allRepLength">
                                        <div style="width: 100%;height: 40px;display: flex;">
                                            <div style="width: 35px; height: 35px;cursor: pointer;cursor: pointer;"@click="circle(ite.uuid,ite.user.userType)">
                                                <img :src="ite.user.headIco" style="width: 35px;height: 35px;border-radius: 30%;">
                                            </div>
                                            <div style="width:auto; line-height: 35px;padding-left: 10px;cursor: pointer;color: #EB7350;"@click="circle(ite.uuid,ite.user.userType)">{{ite.user.nickName}}</div>
                                        </div>
                                        <div style="width: 100%;height: auto;display: flex;">
                                            <div v-if="ite.regInfo.reg == 0">
                                                <div style="width: auto;line-height: 20px;margin-left: 0px">{{ite.content}}</div>
                                            </div>

                                            <div v-if="ite.regInfo.reg == 1">
                                                <div style="width: auto;line-height: 20px;">
                                                    {{ite.content}}
                                                    回复<span @click="circle(ite.regInfo.uuid,ite.regInfo.userType)"  style="color: blue;cursor: pointer;">//{{ite.regInfo.regUserName}}</span>
                                                    <span >:{{ite.regInfo.repContent}}</span>
                                                </div>
                                            </div>
                                            <div style="width: auto;text-align: center;height: auto;padding-left: 10px;">{{ite.likeCount}}</div>
                                            <div style="width: 20px;height: auto;padding-left: 3px;">
                                                <div @click="clickLike(ite.id,index,idx,2)" style="width: 20px;height: auto;cursor: pointer;">
                                                    <img v-show="ite.isLike == 0" src="@/assets/imgs/other/dianzan.png" style="width: 20px;height: 18px;">
                                                    <img v-show="ite.isLike == 1" src="@/assets/imgs/other/dianzan2.png" style="width: 20px;height: 18px;">
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="ite.images.length > 0" style="width: 100%;height: auto;display: flex;">
                                            <div style="width: 250px;height: 250px;margin-left: 0px;">
                                                <img style="width: 100%;height: 100%;" :src="ite.images[0].url">
                                            </div>
                                        </div>
                                        <div style="width: 100%;line-height: 25px;cursor: pointer;font-size: 14px;display: flex;">
                                            <div @click="clickRep(index,ite)" style="width: 30px;text-align: center;padding-left: 0px;">回复</div> · <div style="color: #c1c1c1;width: 100px;"> {{ite.createTime}}</div>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="item.childrenConut >= 2 && item.allRepLength != item.childrenConut" style="width: calc(100% - 46px);height: 38px;cursor: pointer;">
                                    <div @click="checkAllTowRep(index,item,1)" style="line-height: 35px;width: 100%;font-size: 14px;">查看全部 {{item.childrenConut}} 条回复 ▽</div>
                                </div>

                                <div  v-if="item.childrenConut > 2 && item.allRepLength == item.childrenConut" style="width: calc(100% - 46px);height: 38px;cursor: pointer;margin-left: 46px;">
                                    <div @click="tionReply[index].allRepLength = 1;tionReply[index].islaunch = 0;" style="line-height: 35px;width: calc(100% - 10px);font-size: 14px;text-align: right;padding-right: 10px;">收起 回复 △</div>
                                </div>
                            </div>
                    </div>
                </div>
                <div v-if="isAllRep == 1" @click="getAllRep" style="background: #FFFFFF;width: 100%;line-height: 35px;margin-bottom: 10px;text-align: center;cursor: pointer;">已全部加载完毕</div>
                <div v-if="data.reviewCount && data.reviewCount.length > 10 && loading == false && isAllRep == 0" @click="getAllRep" style="background: #FFFFFF;width: 100%;line-height: 35px;margin-bottom: 10px;text-align: center;cursor: pointer;">查看更多评论</div>
            </div>
            <div v-if="is_login === 0" style="overflow: hidden;background: #FFFFFF;white-space: pre-wrap;width: calc(100% - 30px;);border-radius: 5px;padding: 10px 0px 50px 15px;" >
               <div style="display: flex;justify-content: center">
                    <div class="op sc hand"><el-button type="primary" size="small" style="font-size: 15px;" @click="logintoview">登录查看评论</el-button></div>
               </div>
            </div>

            <!--回复弹窗(含一级与多级)-->
            <el-dialog :close-on-click-modal="false" :visible.sync="repInputShow" width="40%" v-if="repInputShow == true">
                <multiLevelRep :repInfo="repInfo" @change="setchildren($event)" red="chidInputContent"></multiLevelRep>
            </el-dialog>

    </div>
</template>
<script>
import multiLevelRep from "./multiLevelRep.vue";
export default {
    components: {
        multiLevelRep,
    },
    comments:{

    },
    props: {
        data: {
            type: Object,
            default() {
                return {}
            }
        }
    },

    data() {
        return {
            id:0,
            loading:true,
            tionReply:[],
            playerOptions: {},
            page: 1,
            pageSize:10,
            answers:"采纳答案",
            info: {},
            replyInfo: {title: '',fid: ''},
            isAllRep:0,
            //回复
            showReply:[],
            isCollapsed: true,
            textarea:"",
            repInputShow:false,
            addLike:false,
            addLikeTwo:false,
            repInfo:{},
            repType:0,
        }
    },
    watch:{
        data(newValue, oldValue){
            this.info = this.data
            console.log('replyType data 发生变化：', newValue);
            this.getQuestionReply();
        }
    },

    computed: {
        user() {
            return this.$store.state.user;
        },
        is_login(){
            return this.$store.state.is_login
        }
    },

    mounted() {
        var that = this;
        this.id = this.$route.query.id;
        that.loading = true;
        //接受个一级回答的广播
        this.$EventBus.$on("addQuestionReply", (data) => {
            this.$nextTick(() => {
                that.tionReply.unshift(data);
            });
        });
    },

    methods: {
        //点赞
        clickLike(id,index,idx,type){
            var that = this;
            that.newApi.addQuestionLike({id: id}).then((res)=>{
                if(res.isSuccess == 1){
                    if (type == 1){
                        that.tionReply[index].likeCount = res.data.likeCount;
                        that.tionReply[index].isLike = res.data.isLike;
                        that.utils.sus(res.data.msg);
                    }else if(type == 2){
                        that.tionReply[index].children[idx].likeCount = res.data.likeCount;
                        that.tionReply[index].children[idx].isLike = res.data.isLike;
                        that.utils.sus(res.data.msg);
                    }
                }
            })
        },

        //跳转个人空间
        circle(uuid,userType){
            var that = this;
            if(userType === 1){
                that.utils.b('/circle/mySpace/' + uuid)
            }else if (userType === 2 || userType === 3){
                that.utils.b('/circle/organSpace/' + uuid)
            }
        },

        //获取当前全部回复
        checkAllTowRep(index,item,isAllRep = 0){
            var that = this;
            that.tionReply[index].islaunch = isAllRep;
            that.openLoading("加载中....");
            this.newApi.getAllRepInfo({id: item.id,isAllRep:isAllRep}).then((res)=>{
                for (let i = 0; i < that.tionReply.length; i++) {
                   for (let j = 0; j < res.data.length; j++) {
                       if (that.tionReply[i].id == res.data[j].id) {
                           that.tionReply[i].children = res.data[j].children;
                           that.tionReply[i].allRepLength = res.data[j].allRepLength;
                           that.tionReply[i].childrenConut = res.data[j].childrenConut;
                       }
                   }
                }
            })
        },

        //点击回复
        clickRep(index,item){
            var that = this;
          if (!this.utils.toAuth(1)) {
            return false
          }

            if(item.uuid == this.user.uuid){
                this.utils.err("不能回复自己");
                return false;
            }
            this.repInfo = item;
            this.repInfo.index = index;
            this.repInputShow = true;
        },

        //组装新的回复
        setchildren(index){
            var that = this;
            this.repInputShow = false;
            if (that.tionReply[index].islaunch){
                that.checkAllTowRep(index,that.tionReply[index],1);
            }else{
                that.checkAllTowRep(index,that.tionReply[index],0);
            }
        },

        //采纳红包问答按钮
        accept(e,index){
              var that = this;
              var params ={}
              if(that.data.uuid != that.user.uuid){
                  that.utils.err("只有发布者可以采纳");
                  return false;
              }
              if(that.tionReply[index].IsAdopt == 1) {
                  that.utils.err("已经采纳过了");
              }
              var pennyList = that.info.pennyList;
              params.id = that.tionReply[index].id;
              params.uuid = that.tionReply[index].uuid;
              params.award = e;
              var typeArr = [];
              for (let i = 0; i < pennyList.length; i++) {
                  typeArr.push(pennyList[i].type)
              }
              that.tionReply[index].IsAdopt = 1;
              that.utils.confirm(e + "等奖确定给此人吗？",function (){
                  that.adoptQuestionReply(params);
              })
          },

        adoptQuestionReply(params){
            var that = this;
            that.openLoading("采纳中");
            that.newApi.adoptQuestionReply(params).then((res)=>{
                if(res.isSuccess == 1){
                    that.tionReply = [];
                    that.getQuestionReply();
                    that.utils.sus(res.data);
                    //发送个广播
                    that.$EventBus.$emit('adoptQuestionReply', {code: 1});
                }
            }).catch((err)=>{
                console.log(err)
            })
        },

        // 采纳悬赏问答按钮
        adopt(index){
            var that = this;
            if(that.data.uuid != that.user.uuid){
                that.utils.err("只有发布者可以采纳");
                return false;
            }
            if(that.tionReply[index].IsAdopt == 1){
                that.utils.err("已经采纳过了");
                return false;
            }
            var params ={}
            params.id = that.tionReply[index].id;
            params.uuid = that.tionReply[index].uuid;
            that.utils.confirm("确定采纳给此人吗？",function (){
                that.introductionAdopt(params);
            })
        },

        introductionAdopt(params){
            var that = this;
            that.openLoading("采纳中");
            that.newApi.introductionAdopt(params).then((res)=>{
                if(res.isSuccess == 1){
                    that.tionReply = [];
                    that.getQuestionReply();
                    that.utils.sus(res.data);
                    //发送个广播
                    that.$EventBus.$emit('adoptQuestionReply', {code: 1});
                }
            })
        },

        // 获取回复列表
        getQuestionReply() {
            var that = this;
            this.newApi.getQuestionReply({id: that.id,isAllRep:that.isAllRep}).then((res)=>{
                that.tionReply = res.data;
                that.loading = false;
            })
        },

        // 下载附件事件
        download1 (ind,url,name,hash){
            var that = this;
          if (!this.utils.toAuth(1)) {
            return false
          }
                    if (that.tionReply[ind].auth == 0) {
                        this.utils.err("无权限浏览下载")
                        return false
                    } else {
                        that.utils.download(url,name)
                        // window.open("https://oss.baigongbao.com/2022/12/05/2MShSF6Xh8.docx",'_blank');
                        that.utils.sus("附件已下载")
                        return false
                    }
            },

            //视频播放
            videoOptions(url,img){
                //不公开 判断发布者与自己可以听到语音muted = true 否则无语音 muted = false
                var muted = false;
                var obj = {
                    muted:muted,  //是否静音
                    playbackRates: [0.7, 1.0, 1.5, 2.0],
                    aspectRatio: '16:9',
                    sources: [{
                        src:url
                    }],
                    fluid: true,
                    poster:img,
                    controlBar: {
                        timeDivider: true,
                        durationDisplay: true,
                        remainingTimeDisplay: true,
                        fullscreenToggle: true  //全屏按钮
                    }
                }
                return obj;
            },

            //获取所有评论
            getAllRep(){
                var that = this;
                that.isAllRep = 1;
                that.openLoading('获取中....');
                that.newApi.getQuestionReply({id: that.id,isAllRep:that.isAllRep}).then((res)=>{
                    that.utils.sus("获取完毕");
                    that.tionReply = res.data;
                    that.loading = false;
                })
            },

            // 回答删除方法
            more_action(e){
                var that = this;
                that.utils.confirm("是否删除回答?",function (){
                    that.newApi.deleteQuestionReply({ id: that.tionReply[e].id}).then((res)=>{
                        if(res.isSuccess == 1){
                            //删除元素
                            that.tionReply.splice(e,1);
                            that.utils.sus(res.data);
                        }
                    })
                })
            },
            // 登陆查看评论事件
            logintoview(){
                this.$store.commit('setShowLoginPopup', true);
            }

    }
}

</script>

<style scoped>
.input_dh {
    width: 1350px;
    height: auto;
    overflow: hidden;
    border-radius: 5px 5px 5px 5px;
    margin-left: 80px;
}
/deep/ .el-input__inner {
    /*height: 156px;*/
    height: 30px;
}
/deep/ .el-dialog__body{
    padding: 10px;
}
.comment-btn {
    width: 60px;
    height: 25px;
    border-radius: 15px;
    background: blue;
    color: #FFFFFF;
}
.input_box_btn_name{
    float:left;
    margin-top: 24px;
    cursor:pointer;
}
.input_box_btn_icon{
    float:left;
    font-size:20px;
    line-height:70px;
    margin-right:5px;
}
/*/deep/ .el-textarea__inner {*/
/*    border: 1px solid #606266;*/
/*}*/
.bottom{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    line-height:50px;
    height: 50px;
    color: #444444;
    font-size: 16px;
    text-align: center;
}

.bottom .Function{
    display: flex;
    justify-content:right;
    align-items: center;
    flex: 1;
    cursor: pointer;
    float: left;
    margin: 0 auto;
    margin-right: 35px;
}

.dynamic-operation .data_list {
    width: 50px;
    height: 32px;
    color: #fff;
    margin-top: 20px;
    padding: 10px;
    background-color: #1C7EFF;
    border-radius: 5px;
}

.dynamic-operation .data_type {
    width: 50px;
    height: 32px;
    color: #fff;
    margin-top: 20px;
    padding: 10px;
    background-color: #6d737b;
    border-radius: 5px;
}
.userName{
    color:rgb(85, 85, 85);
    font-size: 16px;
}

.spacebetween{
    display: flex;
    justify-content: space-between;
    align-items: center;
}

</style>
